// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig:{
    apiKey: "AIzaSyCJ1sYfIayPQIm8vTUzHykirAZb9fyvtAc",
    authDomain: "amcurd-55006.firebaseapp.com",
    databaseURL: "https://amcurd-55006.firebaseio.com",
    projectId: "amcurd-55006",
    storageBucket: "amcurd-55006.appspot.com",
    messagingSenderId: "453750186369",
    appId: "1:453750186369:web:b3e7df11b577d6d8cec880",
    measurementId: "G-2D7HKKJ24P"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
